import { isBackgroundSyncSupported } from '@/infrastructure/sync/backgroundSyncSupport';

/** Tag do Background Sync usado pelo `sync` handler do Service Worker
 * (`src/sw.ts`) — Spec Técnica > Migração do Service Worker. */
export const LEAD_SYNC_TAG = 'lead-sync';

/** `ServiceWorkerRegistration.sync` (Background Sync API) não faz parte do
 * `lib.dom.d.ts` padrão do TypeScript — declarado localmente só com o que é
 * usado aqui. */
interface SyncManagerLike {
  register(tag: string): Promise<void>;
}

interface ServiceWorkerRegistrationWithSync extends ServiceWorkerRegistration {
  readonly sync: SyncManagerLike;
}

/**
 * Agenda a sincronização da fila via Background Sync API (CA-04): chamado
 * ao enfileirar um lead e ao reconectar. Devolve `false` sem fazer nada
 * quando o navegador não suporta Background Sync — quem chama deve
 * recorrer ao fallback de polling (CA-06) nesse caso.
 *
 * Falha ao registrar (ex.: permissão negada) é logada estruturada e não
 * propaga exceção — a fila permanece intacta no IndexedDB e será
 * retentada pelo fallback de polling ou na próxima chamada a esta função.
 */
export async function scheduleLeadSync(): Promise<boolean> {
  if (!isBackgroundSyncSupported()) return false;

  try {
    const registration = (await navigator.serviceWorker.ready) as ServiceWorkerRegistrationWithSync;
    await registration.sync.register(LEAD_SYNC_TAG);
    return true;
  } catch (error) {
    console.error(
      '[scheduleLeadSync] Falha ao registrar Background Sync — fallback de polling assume.',
      { error: error instanceof Error ? error.message : String(error) }
    );
    return false;
  }
}
